// EN
export const derivedRatesSection = {
  title: "Tarifs dérivés",
  description:
    "Créez des tarifs basés sur vos plans tarifaires principaux pour vous connecter à différents OTA tout en conservant un prix de base centralisé.",
  newRate: "Nouveau tarif dérivé",
  loading: "Chargement des tarifs...",

  otaBadge: "OTA",
  otaLockedTitle: "Tarif OTA : géré depuis 'Connecter OTA'",
  salePaused: "Ventes suspendues",

  columns: {
    name: "Nom",
    adjustment: "Ajustement",
    finalPrice: "Prix final",
  },

  actions: {
    resumeTitle: "Reprendre les ventes sur Channex",
    pauseTitle: "Suspendre les ventes sur Channex (stop_sell)",
    edit: "Modifier",
    delete: "Supprimer",
    protectedTitle: "Protégé : modifiez-le ou supprimez-le depuis 'Connecter OTA'",
  },

  empty: {
    title: "Aucun tarif dérivé",
    text: "Créez des tarifs dérivés basés sur vos plans tarifaires principaux pour vous connecter aux OTA",
    create: "Créer le premier tarif dérivé",
  },

  modal: {
    editTitle: "Modifier le tarif dérivé",
    createTitle: "Nouveau tarif dérivé",
    baseRatePlan: "Plan tarifaire de base",
    selectBasePlaceholder: "Sélectionnez un plan tarifaire de base",
    selectBaseHint:
      "Sélectionnez le plan tarifaire à partir duquel ce tarif dérivé sera calculé",
    nameLabel: "Nom du tarif dérivé",
    namePlaceholder: "ex. tarif Booking.com, tarif Airbnb",
    nameHint: "Ce nom vous aidera à identifier le tarif lors de la connexion avec les OTA",
    adjustmentType: "Type d'ajustement",
    percentage: "Pourcentage",
    fixedAmount: "Montant fixe",
    adjustmentValue: "Valeur de l'ajustement",
    adjustmentValueHint: "(utilisez des valeurs négatives pour les remises)",
    cancel: "Annuler",
    saving: "Enregistrement...",
    update: "Mettre à jour",
    create: "Créer le tarif",
  },

  preview: {
    title: "Aperçu",
    basePrice: "Prix de base",
    increment: "Augmentation",
    discount: "Remise",
    finalPrice: "Prix final",
  },

  delete: {
    title: "Supprimer le tarif dérivé",
    warnStrong: "Cette action est irréversible.",
    warnText:
      "Avant de supprimer, assurez-vous que le tarif {name} n'est lié à aucun OTA.",
    confirmLabel: "Saisissez le nom exact pour confirmer :",
    confirmPlaceholder: "Saisissez le nom exact du tarif",
    confirmHint:
      "Collez ou saisissez le nom exactement tel qu'il apparaît ci-dessus pour activer le bouton de suppression.",
    cancel: "Annuler",
    processing: "Suppression...",
    confirm: "Supprimer définitivement",
  },

  pause: {
    resumeTitle: "Reprendre les ventes",
    pauseTitle: "Suspendre les ventes",
    resumeText:
      "{code} sera envoyé à Channex pour les 500 prochains jours. Le canal recommencera à recevoir des disponibilités et pourra accepter des réservations.",
    pauseText:
      "{code} sera envoyé à Channex pour les 500 prochains jours. Le canal lié à ce tarif ne pourra pas accepter de nouvelles réservations pendant la suspension.",
    note: "Le calendrier principal et les autres canaux ne seront pas affectés. Pour reprendre, cliquez sur le bouton ▶ du tarif.",
    cancel: "Annuler",
    resuming: "Reprise...",
    pausing: "Suspension...",
    confirmResume: "Oui, reprendre les ventes",
    confirmPause: "Oui, suspendre les ventes",
  },

  toast: {
    loadError: "Erreur lors du chargement des données",
    fillRequired: "Veuillez remplir tous les champs obligatoires",
    updated: "Tarif mis à jour avec succès",
    created: "Tarif créé avec succès",
    saveFailed: "Impossible d'enregistrer le tarif",
    saveError: "Erreur lors de l'enregistrement du tarif dérivé",
    deleted: "Tarif dérivé supprimé",
    deleteFailed: "Impossible de supprimer le tarif",
    deleteLinkedOta: "Suppression impossible : le tarif est lié à un OTA.",
    nameMismatch: "Le nom saisi ne correspond pas.",
    deleteError: "Erreur lors de la suppression du tarif dérivé",
    salesPaused: "Ventes suspendues",
    salesResumed: "Ventes reprises",
    toggleFailed: "Impossible de changer le statut",
    toggleError: "Erreur lors du changement de statut du tarif",
    // Guardada en local, pero Channex no aceptó el cambio (channex_synced:false).
    channexNotSynced: "Le tarif a été enregistré, mais le channel manager n'a pas accepté la modification : les canaux gardent la version précédente. Vérifiez les données et réessayez.",
  },

  // Estancia mínima propia de una derivada (own_min_stay). Campo y chip
  // compartidos: OwnMinStayField.vue / OwnMinStayChip.vue.
  ownMinStay: {
    label: "Séjour minimum propre (nuits)",
    hint: "Vide = le même que le tarif principal",
    mixedPlaceholder: "Divers",
    mixedHint: "Chaque chambre a un minimum différent. Si vous en saisissez un, il s'appliquera à toutes ; si vous laissez vide, chacune garde le sien.",
    // Sugerencia por el nombre («Tarifa semanal» → 7): una pregunta de un clic.
    suggestQuestion: "Minimum {n} nuit ? | Minimum {n} nuits ?",
    suggestUse: "Utiliser",
    clear: "Retirer",
    channelNote: "{channel} recevra un minimum de {n} nuit pour ce tarif. | {channel} recevra un minimum de {n} nuits pour ce tarif.",
    genericNote: "Les canaux connectés (Booking, etc.) recevront un minimum de {n} nuit pour ce tarif. | Les canaux connectés (Booking, etc.) recevront un minimum de {n} nuits pour ce tarif.",
    chip: "Min. {n} nuit | Min. {n} nuits",
    chipMixed: "Min. différent par chambre",
    chipTitle: "Séjour minimum propre à ce tarif : il est envoyé aux canaux connectés",
    // Grupo con mínimos distintos: quitárselo a todas es un gesto aparte.
    clearAll: "Retirer le minimum à toutes",
    clearedAllHint: "À l'enregistrement, toutes perdront leur minimum propre et utiliseront celui du tarif principal.",
    undo: "Annuler",
  },
};
